import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const ListEmptyState = ({ t }) => {
  return (
    <div className="list-empty-state">
      <div className="list-empty-illustration">
        <div className="list-empty-icon">
          <span className="material-symbols-outlined">list</span>
        </div>
        <div className="list-empty-ripple list-empty-ripple-1" />
        <div className="list-empty-ripple list-empty-ripple-2" />
        <div className="list-empty-ripple list-empty-ripple-3" />
      </div>
      <h3 className="list-empty-title">
        {t('listView:emptyStateTitle')}
      </h3>
      <p className="list-empty-description">
        {t('listView:emptyStateDescription')}
      </p>
    </div>
  );
};

ListEmptyState.propTypes = {
  t: PropTypes.func.isRequired,
};

export default ListEmptyState;
